import { OMSUser } from "@redotech/redo-fulfillment-group-common/oms-user";
import { fgWmsFilterEntries } from "@redotech/redo-fulfillment-operations-common/views/fulfillment/fg-filter-catalog";
import UserIcon from "@redotech/redo-icons/user-01.svg";
import { ArrayStringFilterOperator } from "@redotech/redo-views-common/advanced-filters/array-string-filter";
import { ArrayStringTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

const entry = fgWmsFilterEntries.assignedPicker;

export const AssignedPickerFilter = (
  users: OMSUser[],
): ArrayStringTableFilter<OMSUser> => ({
  type: entry.type,
  data: {
    name: entry.name,
    type: entry.type,
    value: [],
    operator: ArrayStringFilterOperator.ANY_OF,
  },
  operators: entry.operators,
  itemLabel: "picker",
  Icon: UserIcon,
  values: users,
  stringify: (item: OMSUser | string) => {
    return typeof item === "string" ? item : item._id;
  },
  display: (item: OMSUser | string) => {
    if (typeof item === "string") {
      return users.find((user) => user._id === item)?.name || item;
    } else {
      return item.name;
    }
  },
  displayName: entry.displayName,
});
